import { IDropdown } from "../models/input";

export const SUCCESS_MESSAGES = {
    FETCH_SUCCESS: 'Data retrieved successfully',
    POST_SUCCESS: 'Data posted successfully',
    UPDATE_SUCCESS: 'Data updated successfully',
    DELETE_SUCCESS: 'Data deleted successfully',
    LOGIN_SUCCESS: 'Login successful',
    LOGOUT_SUCCESS: 'Logout successful',
    SUCCESS: 'The server successfully returned the requested data.',
    CREATED: 'Create or modify data successfully. ',
    ACCEPTED: 'A request has entered the background queue (asynchronous task). ',
    SUCCESSFULLY_DELETED: 'Delete data successfully. ',
};

export const ERROR_MESSAGES = {
    FETCH_ERROR: 'Failed to retrieve data',
    POST_ERROR: 'Failed to post data',
    UPDATE_ERROR: 'Failed to update data',
    DELETE_ERROR: 'Failed to delete data',
    LOGIN_ERROR: 'Failed to login',
    LOGOUT_ERROR: 'Failed to logout',
    NETWORK_ERROR: 'No response received from the server',
    UNEXPECTED_ERROR: 'An unexpected error occurred',

    BAD_REQUEST: 'There was an error in the request sent, and the server did not create or modify data. ',
    UNAUTHORIZED: 'The user does not have permission (the token, username, password are wrong). ',
    FORBIDDEN: 'The user is authorized, but access is forbidden. ',
    NOT_FOUND: 'The request sent is for a record that does not exist, and the server is not operating. ',
    NOT_ACCEPTABLE: 'The requested format is not available. ',
    GONE: 'The requested resource has been permanently deleted and will no longer be available. ',
    UNPROCESSABLE_ENTITY: 'When creating an object, a validation error occurred. ',
    INTERNAL_SERVER_ERROR: 'An error occurred in the server, please check the server. ',
    BAD_GATEWAY: 'Gateway error. ',
    SERVICE_UNAVAILABLE: 'The service is unavailable, the server is temporarily overloaded or maintained. ',
    GATEWAY_TIMEOUT: 'The gateway has timed out. ',
    ACTION_NOT_ALLOWED: 'The action you attempted is not allowed. Please contact support if you believe this is an error.',
    DEFAULT: 'Service currently unavailable. Please try after some times or contact support.'
};

export const API_STATUS_CODES = {
    SUCCESS: 200,
    CREATED: 201,
    ACCEPTED: 202,
    NO_CONTENT: 204,

    BAD_REQUEST: 400,
    UNAUTHORIZED: 401,
    FORBIDDEN: 403,
    NOT_FOUND: 404,
    ACTION_NOT_ALLOWED: 405,
    NOT_ACCEPTABLE: 406,
    GONE: 410,
    UNPROCESSABLE_ENTITY: 422,

    INTERNAL_SERVER_ERROR: 500,
    BAD_GATEWAY: 502,
    SERVICE_UNAVAILABLE: 503,
    GATEWAY_TIMEOUT: 504,
};

export const NOTIFICATION_TYPES = {
    SUCCESS: 'success' as const,
    ERROR: 'error' as const,
    INFO: 'info' as const,
    WARNING: 'warning' as const,
};

export const NOTIFICATION_TITLE = {
    SUCCESS: 'success',
    FAILED: 'failed',
    INFO: 'Information',
    WARNING: 'Warning',
};

export const LOGIN_TYPES = {
    LOGIN: 'login' as const,
    FORGOT_PASSWORD: 'forgot-password' as const,
    RESET_PASSWORD: 'reset-password' as const,
    CHANGE_PASSWORD: 'change-password' as const
}

export const ROLES = {
    SUPER_ADMIN: 1,
    DATA_MANAGER: 2,
    DATA_COLLECTOR: 3,
    READ_ONLY_USER: 4
}